"use client";

import { Shield, FileCheck, Lock } from "lucide-react";
import { useI18n } from "@/lib/i18n/I18nProvider";

export function SecuritySection(): JSX.Element {
  const { t } = useI18n();

  const SECURITY_ITEMS = [
    {
      icon: Shield,
      title: t("landing.security.isolationTitle"),
      description: t("landing.security.isolationDesc"),
    },
    {
      icon: FileCheck,
      title: t("landing.security.auditTitle"),
      description: t("landing.security.auditDesc"),
    },
    {
      icon: Lock,
      title: t("landing.security.encryptionTitle"),
      description: t("landing.security.encryptionDesc"),
    },
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-50/50">
      <div className="max-w-5xl mx-auto">
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-keiront-obsidian">
            {t("landing.security.title")}
          </h2>
        </div>

        <div className="space-y-8 mb-12">
          {SECURITY_ITEMS.map((item, index) => {
            const Icon = item.icon;
            return (
              <div key={index} className="flex gap-6">
                <div className="flex-shrink-0">
                  <div className="flex items-center justify-center w-14 h-14 rounded-lg bg-keiront-green/10">
                    <Icon className="w-7 h-7 text-keiront-green" />
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-keiront-obsidian mb-2">
                    {item.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed">{item.description}</p>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center">
          <a
            href="/about"
            className="inline-flex items-center gap-2 bg-keiro-green hover:bg-keiro-green-dark text-white px-6 py-3 text-base font-semibold rounded-lg transition-colors"
          >
            {t("landing.cta.learnCompliance")}
          </a>
        </div>
      </div>
    </section>
  );
}
